// import {
//   // getCarModelOeCodes,
//   prebuy,
//   saveOrUpdate,
//   // getDataList,
//   // getListAddress,
//   getattention
// } from '@/api/goodsList.js'

import { getDiscount, switchStore } from '@/api/buyagain.js'

export const index = {
  data() {
    return {
      // cityList: [],
      isCity: ''
      // spinShow: false,
      // show: false
      // pager: {
      //   current: 1,
      //   total: 0,
      //   size: 10
      // },
      // dataList: [],
      // tenantId: JSON.parse(localStorage.getItem('userdetails_tenantInfo'))
      //   .tenantId
    }
  },
  methods: {
    //  *********** 动画样式 *********
    beforeEnter(el) {
      el.style.opacity = 0
    },
    enter(el, done) {
      // console.log(el.dataset.index)
      let delay = el.dataset.index * 100
      setTimeout(() => {
        el.style.transition = 'opacity 0.4s '
        el.style.opacity = 1
        el.style.animation = 'one-in 0.4s infinite'
        el.style['animation-iteration-count'] = 1
        done()
      }, delay)
    },
    // 鼠标移开(关闭oe)
    closeRelevance(index) {
      console.log(index)
      this.$set(this.dataList[index], 'isShow', false)
    },
    // 鼠标移开(关闭发货地)
    closeCity(index) {
      // console.log(index)
      this.$set(this.dataList[index], 'isShows', false)
    },
    // 鼠delete标经过(展开oe码)
    getRelevance(index) {
      this.$set(this.dataList[index], 'isShow', true)
    },
    // 发货地选中
    async checkCITY(i, item) {
      const res = await switchStore({ id: item.id, storeId: i.storeId })
      console.log(res)
      if (res.status) {
        this.isCity = i.name
        item.shipCityStore = i
        item.stock = i.stock
      }
    },
    // 鼠标经过(展开发货地)
    getCity(item) {
      this.isCity = item.shipCityStore.name
      this.$set(item, 'isShows', true)
    },
    // 鼠标移开(关闭发货地)
    closeCity(item) {
      this.$set(item, 'isShows', false)
    },
    async BlurNumber(item, val) {
      console.log(item)
      let reg = /^[1-9]\d*$/
      if (!reg.test(item.partNum)) {
        this.$Message.error('请输入正确的购买数量！')
      } else {
        if (item.inquiry == 1) {
        } else {
          if (val == 1) {
            console.log('555555')
            if (item.partNum > item.shipCityStore.stock) {
              this.$set(item, 'Add', true)
              // this.$set(item, 'isNumber', true)
            } else if (item.partNum == item.shipCityStore.stock) {
              this.$set(item, 'Add', true)
              this.$set(item, 'isNumber', false)
            } else {
              this.$set(item, 'Add', false)
              this.$set(item, 'isNumber', false)
              if (item.partNum == 1) {
                this.$set(item, 'Sub', true)
              }
            }
          } else {
            console.log('666666')
            if (item.partNum > item.shipCityStore.stock) {
              this.$set(item, 'Add', true)
              this.$set(item, 'isNumber', true)
            } else if (item.partNum == item.shipCityStore.stock) {
              this.$set(item, 'Add', true)
              this.$set(item, 'isNumber', false)
            } else {
              this.$set(item, 'Add', false)
              this.$set(item, 'isNumber', false)
              if (item.partNum == 1) {
                this.$set(item, 'Sub', true)
              }
            }
          }
        }
        // console.log(item.id, item.partNum)
        const res = await getDiscount({
          id: item.id,
          num: item.partNum
        })
        if (res.status) {
          item.subtotal = res.data.subtotal
          item.price = res.data.price
          this.getCount()
        }
      }
    },
    // 减法
    cliSub(item, id) {
      console.log(item.partNum,item.stock, '减法');
      if (item.partNum == 1) {
        // this.$set(this.dataList[index], 'Sub', true)
      } else if (item.partNum == item.stock) {
        console.log('8999999');
        this.$set(item, 'Add', true)
        this.$set(item, 'isNumber', false)
      } else {
        let oipt = document.getElementById(id)
        this.$delete(item, 'partNum')
        this.$set(item, 'partNum', oipt.value * 1 - 1)
        this.BlurNumber(item, 1)
        // this.$set(this.dataList[index], 'Sub', false)
      }
    },
    // 加法
    cliAdd(item, id) {
      console.log(item, id)
      if (item.partNum == item.stock) {
        this.$set(item, 'Add', true)
      } else {
        let oipt = document.getElementById(id)
        console.log(oipt)
        console.log(oipt.value)
        this.$set(item, 'partNum', oipt.value * 1 + 1)
        console.log(item.partNum)
        this.BlurNumber(item, 1)
      }
    },
    // 分页
    changeCurrent(current) {
      this.pager.current = current
      this.searchlist.current = current
      this.getAgainlist()
    },
    changeSize(size) {
      console.log(size)
      this.searchlist.size = size
      this.pager.size = size
      this.pager.current = 1
      this.searchlist.current = 1
      this.getAgainlist()
    }
  }
}
